import { Component, Input, OnInit } from '@angular/core';
import { Feed, HPData } from '../home-page.data';
import { HomePageService } from '../home-page.service';
import { ApplicationRouterService } from '../../@core/application-router/application-router.service';
import { RouteExecutor } from '../../@core/application-router/route.executor';
import { MediaCDNService } from 'src/app/@core/media-cdn.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-home-page-v2',
    templateUrl: './home-page-v2.component.html',
    styleUrls: ['./home-page-v2.component.scss', '../home-page.component.scss'],
})
export class HomePageV2Component extends RouteExecutor implements OnInit {
    @Input() item: HPData = new HPData();
    @Input() showShimmer = false;

    webm = ',f-webm';
    selectedTab = 0;
    tabData: Feed | undefined;
    iosWeb = false;
    posterImageCDN = '';
    isBot = true;

    constructor(
        public homepageService: HomePageService,
        applicationRouterService: ApplicationRouterService,
        public mediaCDN: MediaCDNService,
        public dialog: MatDialog
    ) {
        super(applicationRouterService);
    }

    ngOnInit(): void {
        if (
            this.item?.layoutContent?.feed &&
            this.item?.layoutType === 'category-tab-section'
        ) {
            this.tabData = this.item?.layoutContent?.feed[this.selectedTab];
        }
        this.iosWeb = /iPad|iPhone|iPod/.test(navigator.userAgent);
        this.posterImageCDN = this.mediaCDN.getImageCDN();
    }

    executeFunctionLink(id: string, query: { [p: string]: string | string[] }) {
        switch (query?.action) {
            case 'change-tab': {
                this.selectedTab = +query?.index;
                const index = +query?.index;
                if (this.item?.layoutContent?.feed) {
                    this.tabData = this.item?.layoutContent?.feed[index];
                }
                break;
            }
        }
    }
}
